import app from '@/js/app.js';
import notify from '@/js/helpers/notify.js';

import store from '@/store/index.js';

const questionMessage = {
  id: null,
  answers: [],
  isQuestion: true,
  type: 'received',
  date: '',
  userId: null,
  title: '',
  text: '',
  image: null,
  audioList: [],
  videoList: [],
  attachment: null
};

const wsActionManager = (res = {}) => {
  if (!Object.keys(res).length) return;

  const { action } = res;

  switch (action) {
    // Изменился баланс
    case 'balance': {
      const { data: amount } = res;

      app.$f7.views.main.router.navigate('/notification-popup', {
        props: {
          icon: 'success',
          title: 'Thank you',
          text: `You have replenished the balance by ${amount}$`,
          mainHandlerText: 'Continue',
          mainHandlerActionType: 'CONTINUE'
        }
      });

      store.commit('user/SET_USER_BALANCE', { amount });

      break;
    }

    case 'current_balance': {
      store.commit('user/SET_CURRENT_USER_BALANCE', { amount: res.data });
      break;
    }

    case 'current_gold': {
      const { gold: coin } = res.data;

      store.commit('user/DECREMENT_COIN', { coin });
      break;
    }

    // Закончилось время поиска учителя
    case 'end_request_time': {
      notify({ text: 'Waiting time is up' });

      store.commit('request/REMOVE_REQUEST');

      app.$f7.views.leftPanel.router.navigate('/main-panel', {
        clearPreviousHistory: true
      });

      break;
    }

    case 'lesson_booked': {
      const {
        booking: { id, start, level_id, language_id }
      } = res.data;
      store.commit('user/SET_BOOKING_HISTORY', [
        {
          id,
          start,
          levelId: +level_id,
          languageId: +language_id
        }
      ]);

      break;
    }

    // Учитель принял заявку
    case 'lesson_start': {
      const {
        lesson: { id, video, start },
        teacher
      } = res.data;

      const lesson = {
        id,
        video,
        start,
        teacher
      };

      store.commit('lesson/SET_LESSON', { lesson });

      app.$f7.views.leftPanel.router.navigate('/main-panel', {
        clearPreviousHistory: true
      });
      app.$f7.views.main.router.navigate('/chat', {
        clearPreviousHistory: true
      });

      break;
    }

    // case 'start_video': {
    //   store.commit('lesson/SET_VIDEO_START');
    //   break;
    // }

    // Новое сообщение
    case 'new_message': {
      const {
        id,
        created_at,
        mark,
        quote,
        quote_date,
        user_id,
        text,
        attachments
      } = res.data;

      const message = {
        id,
        type: user_id === store.state.user.info.id ? 'sent' : 'received',
        date: created_at,
        userId: user_id,
        text,
        mark,
        quote,
        quoteDate: quote_date,
        attachment:
          attachments && attachments.length
            ? {
                src: attachments[0].src,
                name: attachments[0].name,
                type: attachments[0].type,
                size: attachments[0].size
              }
            : null
      };

      store.commit('chat/SET_MESSAGE', { message });

      break;
    }

    case 'new_question': {
      const {
        answers,
        // audio,
        body,
        id,
        created_at
        // image,
        // name,
        // video
      } = res.data;

      if (body) {
        store.commit('chat/SET_MESSAGE', {
          message: { ...questionMessage, id, text: body, date: created_at }
        });
      }

      if (answers.items.length) {
        store.commit('chat/SET_MESSAGE', {
          message: {
            ...questionMessage,
            id,
            answers: answers.items,
            date: created_at
          }
        });
      }
      break;
    }

    case 'message_marked': {
      const { message_id: messageId, mark } = res.data;

      store.commit('chat/SET_MESSAGE_MARK', { messageId, mark });
      break;
    }

    // Закончился урок
    case 'lesson_end_time': {
      app.$f7.views.main.router.navigate('/notification-popup', {
        clearPreviousHistory: true,
        props: {
          icon: 'attention',
          title: 'Time is up',
          subtitle: 'your lesson is over',
          mainHandlerText: 'Go home',
          mainHandlerActionType: 'COMPLETE'
        }
      });

      break;
    }

    // Закончились деньги во время урока
    case 'not_enough_money_to_lesson': {
      app.$f7.views.main.router.navigate('/notification-popup', {
        clearPreviousHistory: true,
        props: {
          icon: 'attention',
          title: 'Not enough money',
          subtitle: 'your lesson is over',
          text: 'Refill your account to continue using the application.',
          mainHandlerText: 'Go home',
          mainHandlerActionType: 'COMPLETE'
        }
      });

      break;
    }
  }
};

export default wsActionManager;
